import React, { useEffect } from 'react';

export const StripePricingTable = () => {
  const pricingTableId = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  useEffect(() => {
    const script = document.createElement('stripe-pricing-table');

    script.setAttribute('pricing-table-id', pricingTableId);
    script.setAttribute('publishable-key', publishableKey);

    document.getElementById('stripe-pricing-table').appendChild(script);
  }, []);

  return <div id="stripe-pricing-table" />;
};
